import angular from 'angular';
import ngTouch from 'angular-touch';
import ngSanitize from 'angular-sanitize';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import uiTree from 'angular-ui-tree';
import ngFileUpload from 'ng-file-upload';
import ngFire from 'angularfire';


import _ from 'lodash';
import 'angular-xeditable';   //Why is it different than other ones? Read here: https://github.com/angular-ui/angular-google-maps/issues/1633
import 'selection-model';
//import 'textAngular';
import 'bootstrap-sass';
import 'ng-toast';
import 'ng-tags-input';

import duScroll from 'angular-scroll';

import firebase from  'firebase';
import AngularGoogleAnalytics from 'angular-google-analytics';


import animations from './animations/animations';
//import directives from './directives/directives';
import services from './services/services';
import firebaseFactory from './services/firebaseFactory';
import utilities from './services/utilities';
import contentfulservices from './services/contentfulFactory';

import loadingDirective from './directives/loading/loadingDirective';
import charcountDirective from './directives/charcountDirective';

import headerView from './views/app.header/AppHeaderView.html';
import headerCtrl from './views/app.header/AppHeaderCtrl';

import sideNavCtrl from './views/app.sidenav/AppSideNavCtrl';
import sideNavView from './views/app.sidenav/AppSideNavView.html';
import sideNavBiggerView from './views/app.sidenav/AppSideNavBiggerView.html';

import sideNavUserCtrl from './views/app.sidenav/AppSideNavUserCtrl';
import sideNavUserView from './views/app.sidenav/AppSideNavUserView.html';

import footerView from './views/app.footer/AppFooterView.html';

import AppCtrl from './views/app/AppCtrl';
import appView from './views/app/appView.html';
import appSideView from './views/app/appSideView.html';

import AppHomeCtrl from './views/app.home/AppHomeCtrl';
import appHomeView from './views/app.home/appHomeView.html';

import AppPageCtrl from './views/app.page/appPagesListCtrl';
import appPageView from './views/app.page/appPagesList.html';

import AppPageEditCtrl from './views/app.page/appPagesEditCtrl';
import appPageEditView from './views/app.page/appPagesEdit.html';


import AppItemsCtrl from './views/app.item/appItemsCtrl';
import appItemsView from  './views/app.item/appItems.html';

import AppItemsListCtrl from './views/app.item/appItemsListCtrl';
import appItemsListView from './views/app.item/appItemsList.html';
import appSideItemsView from  './views/app.item/appSideItems.html';

import appSideNavFilesView from './views/app.sidenav/AppSideNavFilesView.html';
import AppSideNavFilesCtrl from './views/app.sidenav/AppSideNavFilesCtrl';

import AppItemsAddEditCtrl from './views/app.item/appItemsAddEditCtrl';
import appItemsAddEditView from './views/app.item/appItemsAddEdit.html';

import AppItemsDetailCtrl from './views/app.item/appItemsDetailCtrl';
import appItemsDetailView from './views/app.item/appItemsDetail.html';

import appLoginCtrl from './views/app.login/appLoginCtrl';
import appLoginView from './views/app.login/appLoginModal.html';

import appUserView from './views/app.user/appUsers.html';
import appUserCtrl from './views/app.user/appUsersCtrl';

import appFileView from './views/app.file/appFileView.html';
import AppFileCtrl from './views/app.file/appFileCtrl';

import appNavigationItemView from './views/app.navigationitem/appNavigationItemView.html';
import AppNavigationItemCtrl from './views/app.navigationitem/appNavigationItemCtrl';

import linkOptionsView from './views/app.modal/linkOptionsModal.html';
import linkOptionsCtrl from './views/app.modal/linkOptionsModalCtrl';




import LanguageService from './services/languagesFactory';

import ngInfiniteScroll from 'ng-infinite-scroll';

import imageCropper from './libs/imageCropper';

import RzSlider from 'angularjs-slider';
/**
 * Register main angular app
 */
export default angular.module('contentfulCustomCmsApp', [
    ngTouch,
    ngSanitize,
    uiRouter,
    animations,
    loadingDirective,
    'selectionModel',
    services,
    firebaseFactory,
    utilities,
    contentfulservices,
    uiBootstrap,
    'xeditable',
    require('../../node_modules/textangular/dist/textAngular.umd'),
    imageCropper,
    uiTree,
    ngFileUpload,
    require('angular-cookies'),
    ngInfiniteScroll,
    ngFire,
    'ngToast',
    'angular-character-count',
    AngularGoogleAnalytics,
    'ngTagsInput',
    duScroll,
    RzSlider
])
    .constant('CONFIG', {
        // Content management API URL
        cmApiUrl: 'https://api.contentful.com/spaces/erjaey3bjggb/', // override below
        // Content delivery API URL
        cdApiUrl: 'https://cdn.contentful.com/spaces/erjaey3bjggb/', // override below
        // Preview API
        prApiUrl: 'https://preview.contentful.com/spaces/erjaey3bjggb/', // Not use anymore
        // Upload API
        uploadUrl: 'https://upload.contentful.com/spaces/erjaey3bjggb/', // override below
        // Images API
        imagesUrl: 'https://images.contentful.com/spaces/erjaey3bjggb/', // Not use anymore
        // File upload URL
        customUploadUrl: 'https://bw-football-contentful-dev.appspot.com/',
        space_id: 'erjaey3bjggb',
        content_management_api_key: '88fff7c07ac417159a61ccfcef167584e10060b418a433f4679b85a20b608805', // override below
        previewApiURL: '',
        paginationResultsPerPage: 10,
        paginationResultsPerPageModal: 60,
        paginationLinksOffset: 4
    })
    .run(['$rootScope', '$location', ($rootScope) => {
        $rootScope.allowNavigation = () => {
            $rootScope._preventNavigation = false;
            $rootScope.dirtyElems = false;
        };

        $rootScope.preventNavigation = () => {
            $rootScope._preventNavigation = true;
            $rootScope.dirtyElems = true;
        }

        $rootScope.$on('$stateChangeStart', (event, newState) => {
            if ($rootScope._preventNavigation && !confirm($rootScope.T.MESSAGE_RELOAD_PAGE)) {
                event.preventDefault();
            }
            else {
                $rootScope.dirtyElems = false;
                $rootScope._preventNavigation = false;
                $rootScope.allowNavigation();
            }
        });

        // Take care of preventing navigation out of our angular app
        window.onbeforeunload = () => {
            // Use the same data that we've set in our angular app
            if ($rootScope._preventNavigation) {
                return $rootScope.T.MESSAGE_RELOAD_PAGE;
            }
        };
    }])
    .run(['$rootScope', '$window', ($rootScope, $window) => {
        'ngInject';
        $rootScope.contentTypes = _.indexBy($window.contentfulCustomCmsAppData.contentTypes, 'sys.id');
        $rootScope.raven = $window.raven;
    }])
    .run(['editableOptions', (editableOptions) => {
        'ngInject';
        editableOptions.theme = 'default';
    }])
    .run(($rootScope, $state, $timeout, $window, $location, $firebaseAuth, $uibModal, $cookies, FirebaseFactory) => {
        'ngInject';

        let auth = $firebaseAuth();
        auth.$onAuthStateChanged((firebaseUser) => {
            $rootScope.isLogged = FirebaseFactory.isLogged(firebaseUser);
            //Not logged
            if (!$rootScope.isLogged) {
                $uibModal.open({
                    template: appLoginView,
                    controller: appLoginCtrl,
                    controllerAs: 'vm',
                    resolve: {}
                });
            } else {
                $rootScope.firebaseUser = {};

                if (!!localStorage.getItem('logged_user')) {
                    let logged_user = JSON.parse(localStorage.getItem('logged_user'));
                    $rootScope.firebaseUser.isAdmin = logged_user.isAdmin;
                    $rootScope.firebaseUser.permissions = logged_user.permissions;
                    $rootScope.firebaseUser.name = logged_user.name;
                } else {
                    let ref = FirebaseFactory.getUser(firebaseUser.uid);
                    ref.on('value', (user) => {
                        $rootScope.firebaseUser.isAdmin = !!user.val() && !!user.val().hasOwnProperty('isAdmin') ? user.val().isAdmin : false;
                        $rootScope.firebaseUser.permissions = !!user.val() && !!user.val().hasOwnProperty('permissions') ? user.val().permissions : [];
                        $rootScope.firebaseUser.name = user.val().displayName;
                        let logged_user_info = {
                            isAdmin: !!user.val() && !!user.val().hasOwnProperty('isAdmin') ? user.val().isAdmin : false,
                            permissions: !!user.val() && !!user.val().hasOwnProperty('permissions') ? user.val().permissions : [],
                            name: user.val().displayName,
                            email: firebaseUser.email
                        };
                        localStorage.setItem('logged_user', JSON.stringify(logged_user_info));
                    });
                }

                FirebaseFactory.getIdToken().then((token) => {
                    $cookies.put('token', token);
                }, (e) => {
                    $rootScope.raven.captureException(e);
                    $rootScope.raven.showReportDialog();
                });
            }
        });

        $rootScope.$on('$stateChangeStart', (evt, to, params) => {
            if (to.redirectTo) {
                evt.preventDefault();

                $timeout(() => {
                    $state.go(to.redirectTo, params);
                });
            }
        });

        $rootScope.$on("$stateChangeError", (event, toState, toParams, fromState, fromParams, error) => {
            // We can catch the error thrown when the $requireSignIn promise is rejected
            // and redirect the user back to the home page
            if (error === "AUTH_REQUIRED") {
                $state.go("home");
            }
        });

        $rootScope.$on('$stateChangeSuccess', function (event) {
            $window.ga('send', 'pageview', $location.path());
        });
    })
    .run (['$rootScope', '$cookies', 'CONFIG', '$window', ($rootScope, $cookies, CONFIG, $window) => {
        'ngInject';

        // enable in alpha
        //$rootScope.locale = 'de-de';
        //$cookies.put('locale', 'de-de');
        //$cookies.put('userlang', 'de');

        if (!!!$cookies.get('locale')) {
            $cookies.put('locale', 'de-de');
            $cookies.put('userlang', 'de');
        }

        $rootScope.locale = $cookies.get('locale');

        let langPack = new LanguageService().getLanguagePack($rootScope.locale);

        $rootScope.TC = (value) => {
            return !!value ? _.first(value.split('|')) : [];
        };

        $rootScope.T = langPack;

        let host = $window.location.host.split('.')[0];
        let fakeProduction = $cookies.get('enableProduction');

        if (host.indexOf('localhost') >= 0 || host.indexOf('develop') >= 0) {
            CONFIG.customUploadUrl = 'https://bw-football-contentful-dev.appspot.com/';
            CONFIG.space_id = 'erjaey3bjggb';
            CONFIG.content_management_api_key = $cookies.get('token');
            CONFIG.content_delivery_api_key = 'a679712c0a5df3e639063cc9e90b17ba409a064d22920319b4b256977010e620';
        } else {
            CONFIG.customUploadUrl = 'https://bw-football-contentful.appspot.com/';
            CONFIG.space_id = '1mgney1of7oi';
            CONFIG.content_management_api_key = $cookies.get('token');
            CONFIG.content_delivery_api_key = 'c9548fa3330918f7aa5fed3e8efe2904dc53db9c479d3a98cd0e340d6c62333f';
        }

        if (!!fakeProduction && fakeProduction) {
            CONFIG.customUploadUrl = 'https://bw-football-contentful.appspot.com/';
            CONFIG.space_id = '1mgney1of7oi';
            CONFIG.content_management_api_key = $cookies.get('token');
            CONFIG.content_delivery_api_key = 'c9548fa3330918f7aa5fed3e8efe2904dc53db9c479d3a98cd0e340d6c62333f';
        }

        CONFIG.cmApiUrl = CONFIG.customUploadUrl + 'manage/contentful/spaces/' + CONFIG.space_id + '/';
        CONFIG.uploadUrl = CONFIG.customUploadUrl + 'manage/contentful/spaces/' + CONFIG.space_id + '/';
    }])
    // .config(($compileProvider) => { 'ngInject'; $compileProvider.preAssignBindingsEnabled(true); })   // <---- http://www.codelord.net/2017/01/01/angular-1-dot-6-is-here-what-you-need-to-know/
    .config(($httpProvider, $provide, CONFIG) => {
        'ngInject';
        document.execCommand("AutoUrlDetect", false, false);

        $provide.decorator('taOptions', ['$rootScope', 'taToolFunctions', 'taTranslations', 'taRegisterTool', '$delegate', 'taSelection', '$window', '$timeout', '$uibModal',
            ($rootScope, taToolFunctions, taTranslations, taRegisterTool, taOptions, taSelection, $window, $timeout, $uibModal) => {
                let langPack = new LanguageService().getLanguagePack($rootScope.locale);
                let blockJavascript =  (link) => {
                    if (link.toLowerCase().indexOf('javascript')!==-1) {
                        return true;
                    }
                    return false;
                };

                function getHTML(who, deep){
                    if(!who || !who.tagName) return '';
                    let txt, ax, el= document.createElement("div");
                    el.appendChild(who.cloneNode(false));
                    txt= el.innerHTML;
                    if(deep){
                        ax= txt.indexOf('>')+1;
                        txt= txt.substring(0, ax)+who.innerHTML+ txt.substring(ax);
                    }
                    el= null;
                    return txt;
                }

                function replaceAnchorToWFVStandard (doc) {
                    let paragraphs = doc.getElementsByTagName('P');
                    let blockquotes = doc.getElementsByTagName('blockquote');
                    let uls = doc.getElementsByTagName('UL');

                    _.forEach(paragraphs, (p) => {
                        let anchors = p.getElementsByTagName('A');
                        _.forEach(anchors, (a) => {
                            let isWfvLink = a.href.indexOf('wfv') > 0;
                            let isArticle = a.href.indexOf('article') > 0;
                            let isAsset = a.href.indexOf('asset') > 0;
                            if (isWfvLink) {
                                let id = _.last(a.href.split('/'));
                                if (isArticle) {
                                    a.href = `wfv://entry/article/${id}`;
                                }
                                if (isAsset) {
                                    a.href = `wfv://asset/${id}`;
                                }
                            }
                        });
                    });

                    _.forEach(blockquotes, (p) => {
                        let anchors = p.getElementsByTagName('A');
                        _.forEach(anchors, (a) => {
                            let isWfvLink = a.href.indexOf('wfv') > 0;
                            let isArticle = a.href.indexOf('article') > 0;
                            let isAsset = a.href.indexOf('asset') > 0;
                            if (isWfvLink) {
                                let id = _.last(a.href.split('/'));
                                if (isArticle) {
                                    a.href = `wfv://entry/article/${id}`;
                                }
                                if (isAsset) {
                                    a.href = `wfv://asset/${id}`;
                                }
                            }
                        });
                    });

                    _.forEach(uls, (p) => {
                        let anchors = p.getElementsByTagName('A');
                        _.forEach(anchors, (a) => {
                            let isWfvLink = a.href.indexOf('wfv') > 0;
                            let isArticle = a.href.indexOf('article') > 0;
                            let isAsset = a.href.indexOf('asset') > 0;
                            if (isWfvLink) {
                                let id = _.last(a.href.split('/'));
                                if (isArticle) {
                                    a.href = `wfv://entry/article/${id}`;
                                }
                                if (isAsset) {
                                    a.href = `wfv://asset/${id}`;
                                }
                            }
                        });
                    });

                    $rootScope.newText = getHTML(doc, true);
                }


                taRegisterTool('insertLink1', {
                    tooltiptext: langPack.INSERTLINK_TOOLTIP,
                    iconclass: 'fa fa-link',
                    action: function() {
                        let urlLink;
                        let rangy = require('rangy');
                        let savedSel = rangy.saveSelection();

                        let modalInstance = $uibModal.open({
                            template: linkOptionsView,
                            controller: linkOptionsCtrl,
                            controllerAs: 'vm',
                            resolve: {
                                value () {
                                    return null;
                                }
                            }
                        });

                        modalInstance.result.then((selectedItem) => {
                            if (selectedItem.type === 'in_art') {
                                urlLink = `wfv://entry/article/${selectedItem.item[0].sys.id}`;
                            } else if (selectedItem.type === 'in_fil') {
                                urlLink = `wfv://asset/${selectedItem.item[0].sys.id}`;
                            } else {
                                urlLink = `http://${selectedItem.link}`;
                            }
                            rangy.restoreSelection(savedSel); // puts the selection back in the correct place
                            if(urlLink && urlLink !== '' && urlLink !== 'http://'){
                                if (!blockJavascript(urlLink)) {
                                    this.$editor().wrapSelection('createLink', urlLink, true);
                                    //let doc = document.getElementsByClassName('ta-bind')[0];
                                   // replaceAnchorToWFVStandard(doc);
                                }
                            }
                        }, () => {
                            console.warn(`Modal dismissed at: ${new Date()}`);
                        });
                    },
                    activeState: function(commonElement){
                        if(commonElement) return commonElement[0].tagName === 'A';
                        return false;
                    },
                    onElementSelect: {
                        element: 'a',
                        action: (event, $element, editorScope) => {
                            let rangy = require('rangy');
                            let savedSel = rangy.saveSelection();
                            event.preventDefault();
                            editorScope.displayElements.popover.css('width', '436px');
                            let container = editorScope.displayElements.popoverContainer;
                            container.empty();
                            container.css('line-height', '28px');
                            let host = window.location.host.split('.')[0];
                            let path_article = 'https://wfv-frontend-develop.firebaseapp.com/';
                            let path_file = 'https://bw-football-contentful-dev.appspot.com/';
                            if (host.indexOf('localhost') === -1 && host.indexOf('develop') === -1) {
                                path_article = 'https://wfv-frontend.firebaseapp.com/';
                                path_file = 'https://bw-football-contentful.appspot.com/';
                            }

                            let href = $element.attr('href');
                            let isWFV = href.indexOf('wfv') >= 0;
                            let isArticle = href.indexOf('article') >= 0;
                            let hrefs = href.split('/');

                            let link = angular.element('<a href="' + $element.attr('href') + '" target="_blank">' + $element.attr('href') + '</a>');

                            console.warn('__link', link);

                            if (isWFV) {
                                if (isArticle) {
                                    link = angular.element( `<a href="${path_article}#/artikel/foo/${_.last(hrefs)}/1" target="_blank">${$element.attr('href')}</a>`);
                                } else {
                                    link = angular.element( `<a href="${path_file}contentful/download/${_.last(hrefs)}" target="_blank">${$element.attr('href')}</a>`);
                                }
                            }

                            link.css({
                                'display': 'inline-block',
                                'max-width': '200px',
                                'overflow': 'hidden',
                                'text-overflow': 'ellipsis',
                                'white-space': 'nowrap',
                                'vertical-align': 'middle'
                            });
                            container.append(link);
                            let buttonGroup = angular.element('<div class="btn-group pull-right">');
                            let reLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.reLinkButton.tooltip + '"><i class="fa fa-edit icon-edit"></i></button>');
                            reLinkButton.on('click', function(event){
                                event.preventDefault();
                                let urlLink;

                                let modalInstance = $uibModal.open({
                                    template: linkOptionsView,
                                    controller: linkOptionsCtrl,
                                    controllerAs: 'vm',
                                    resolve: {
                                        value () {
                                            return $element.attr('href');
                                        }
                                    }
                                });

                                modalInstance.result.then((selectedItem) => {
                                    if (selectedItem.type === 'in_art') {
                                        urlLink = `wfv://entry/article/${selectedItem.item[0].sys.id}`;
                                    } else if (selectedItem.type === 'in_fil') {
                                        urlLink = `wfv://asset/${selectedItem.item[0].sys.id}`;
                                    } else {
                                        urlLink = `http://${selectedItem.link}`;
                                    }
                                    rangy.restoreSelection(savedSel); // puts the selection back in the correct place
                                    if(urlLink && urlLink !== '' && urlLink !== 'http://'){
                                        if (!blockJavascript(urlLink)) {
                                            $element.attr('href', urlLink);
                                            $element.attr('target', '_blank');
                                            $element.attr('style', 'text-decoration: underline !important;');
                                            editorScope.updateTaBindtaTextElement();
                                        }
                                    }
                                }, () => {
                                    console.warn(`Modal dismissed at: ${new Date()}`);
                                });

                                /*let urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, $element.attr('href'));
                                if(urlLink && urlLink !== '' && urlLink !== 'http://'){
                                    console.log($element)
                                    $element.attr('href', urlLink);
                                    $element.attr('target', '_blank');
                                    editorScope.updateTaBindtaTextElement();
                                }
                                editorScope.hidePopover();*/
                            });
                            buttonGroup.append(reLinkButton);
                            let unLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.unLinkButton.tooltip + '"><i class="fa fa-unlink icon-unlink"></i></button>');
                            // directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
                            unLinkButton.on('click', function(event){
                                event.preventDefault();
                                $element.replaceWith($element.contents());
                                editorScope.updateTaBindtaTextElement();
                                editorScope.hidePopover();
                            });
                            buttonGroup.append(unLinkButton);
                            let targetToggle = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on">' + taTranslations.editLink.targetToggle.buttontext + '</button>');
                            if($element.attr('target') === '_blank'){
                                targetToggle.addClass('active');
                            }
                            targetToggle.on('click', function(event){
                                event.preventDefault();
                                $element.attr('target', ($element.attr('target') === '_blank') ? '' : '_blank');
                                targetToggle.toggleClass('active');
                                editorScope.updateTaBindtaTextElement();
                            });
                            buttonGroup.append(targetToggle);
                            container.append(buttonGroup);
                            editorScope.showPopover($element);
                        }
                    }
                });


                taRegisterTool('insertMail', {
                    tooltiptext: langPack.INSERTEMAIL_TOOLTIP,
                    iconclass: 'fa fa-envelope',
                    action: function(){
                        // https://github.com/textAngular/textAngular/issues/261
                        let urlLink;
                        if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
                            urlLink = $window.prompt("Please enter an EMAIL to insert", taSelection.getSelectionElement().href);
                        } else {
                            urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, 'mailto:');
                        }
                        if(urlLink && urlLink !== '' && urlLink !== 'mailto:'){
                            if (!blockJavascript(urlLink)) {
                                return this.$editor().wrapSelection('createLink', urlLink, true);
                            }
                        }
                    },
                    activeState: function(commonElement){
                        if(commonElement) return commonElement[0].tagName === 'A';
                        return false;
                    }
                    /*onElementSelect: {
                        element: 'a',
                        action: (event, $element, editorScope) => {
                            console.log(event, $element, editorScope);
                            event.preventDefault();
                            editorScope.displayElements.popover.css('width', '436px');
                            let container = editorScope.displayElements.popoverContainer;
                            container.empty();
                            container.css('line-height', '28px');
                            let link = angular.element('<a href="' + $element.attr('href') + '" target="_blank">' + $element.attr('href') + '</a>');
                            link.css({
                                'display': 'inline-block',
                                'max-width': '200px',
                                'overflow': 'hidden',
                                'text-overflow': 'ellipsis',
                                'white-space': 'nowrap',
                                'vertical-align': 'middle'
                            });
                            container.append(link);
                            let buttonGroup = angular.element('<div class="btn-group pull-right">');
                            let reLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.reLinkButton.tooltip + '"><i class="fa fa-edit icon-edit"></i></button>');
                            reLinkButton.on('click', function(event){
                                console.log('click');
                                event.preventDefault();
                                let urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, $element.attr('href'));
                                if(urlLink && urlLink !== '' && urlLink !== 'http://'){
                                    console.log($element)
                                    $element.attr('href', urlLink);
                                    $element.attr('target', '_blank');
                                    editorScope.updateTaBindtaTextElement();
                                }
                                editorScope.hidePopover();
                            });
                            buttonGroup.append(reLinkButton);
                            let unLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.unLinkButton.tooltip + '"><i class="fa fa-unlink icon-unlink"></i></button>');
                            // directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
                            unLinkButton.on('click', function(event){
                                event.preventDefault();
                                $element.replaceWith($element.contents());
                                editorScope.updateTaBindtaTextElement();
                                editorScope.hidePopover();
                            });
                            buttonGroup.append(unLinkButton);
                            let targetToggle = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on">' + taTranslations.editLink.targetToggle.buttontext + '</button>');
                            if($element.attr('target') === '_blank'){
                                targetToggle.addClass('active');
                            }
                            targetToggle.on('click', function(event){
                                event.preventDefault();
                                $element.attr('target', ($element.attr('target') === '_blank') ? '' : '_blank');
                                targetToggle.toggleClass('active');
                                editorScope.updateTaBindtaTextElement();
                            });
                            buttonGroup.append(targetToggle);
                            container.append(buttonGroup);
                            editorScope.showPopover($element);
                        }
                    }*/
                });
                taOptions.forceTextAngularSanitize = false;

                taOptions.toolbar = [
                    ['bold', 'italics', 'quote', 'insertLink1', 'ul' ,'insertMail']
                    //['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
                    //['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
                    //['html', 'insertImage','insertLink', 'insertVideo', 'wordcount', 'charcount']
                ];

                taTranslations.editLink.targetToggle.buttontext = langPack.NEW_WINDOW;
                taOptions.defaultTagAttributes.a.target = '_blank';

                taTranslations.bold.tooltip = langPack.BOLD_TOOLTIP;
                taTranslations.italic.tooltip = langPack.ITALIC_TOOLTIP;
                taTranslations.quote.tooltip = langPack.QUOTE_TOOLTIP;
                taTranslations.insertLink.tooltip = langPack.INSERTLINK_TOOLTIP;
                //taTranslations.insertLink1.tooltip = langPack.INSERTLINK_TOOLTIP;
                taTranslations.ul.tooltip = langPack.UL_TOOLTIP;

                return taOptions;
            }]);

        $httpProvider.interceptors.push( ($rootScope, $q, ngToast, FirebaseFactory, $cookies, $injector) => {
            return {
                request: (config) => {
                    $rootScope.visible = true;
                    if (config.url.indexOf('api.contentful.com') > -1 ||
                        config.url.indexOf('upload.contentful.com') > -1 ||
                        config.url.indexOf('images.contentful.com') > -1 ||
                        config.url.indexOf('manage/contentful/spaces') > -1) {
                        console.log('X-Auth-Token', $cookies.get('token'));
                        config.headers[ 'X-Auth-Token'] = $cookies.get('token');
                    } else if (config.url.indexOf('cdn.contentful.com') > -1) {
                        config.headers.Authorization = 'Bearer ' + CONFIG.content_delivery_api_key;
                    } /*else if (config.url.indexOf('preview.contentful.com') > -1) {
                        config.headers.Authorization = 'Bearer 865569051dd9a34a0dd1150189561e90e59357e43fa81a6816b889ff547ca973';
                    }*/

                    return config;
                },
                response: (response) => {
                    $rootScope.visible = false;
                    //console.info('request completed successfully');
                    //let successMessage = response.config.successMessage;

                    /* if (successMessage) {
                        Utilities.handlers.success(successMessage);
                    } */

                    return response;
                },
                responseError: (rejection) => {
                    $rootScope.visible = false;

                    if (rejection.status === 401) {
                        console.warn('logout');
                        FirebaseFactory.logout();
                    }
                    if (rejection.status === 403) {
                        ngToast.create({
                            className: 'toast-danger',
                            content: `${$rootScope.T.RESTRICTED_ACCESS}`,
                            timeout: 4000
                        });
                    }

                    if (rejection.status === 500 || rejection.status === 422) {
                        ngToast.create({
                            className: 'toast-danger',
                            content: `${$rootScope.T.HTTP_UPLOAD_ERROR_NOTIFICATION}`,
                            timeout: 4000
                        });

                        $injector.get('$state').reload();
                    }

                    console.error('responseError - rejection', rejection);

                    $rootScope.raven.captureException(rejection);
                    //$rootScope.raven.showReportDialog();

                    return $q.reject(rejection);
                }
            };
        });

    })
    .config(['ngToastProvider', (ngToast) => {
        ngToast.configure({
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
        });
    }])
    .config(['$provide', 'tagsInputConfigProvider', ($provide, tagsInputConfigProvider) => {
        //let langPack = new LanguageService().getLanguagePack($rootScope.locale);

        tagsInputConfigProvider
            .setDefaults('tagsInput', {
                placeholder: 'Neue Schlagwörter'
            })
            .setDefaults('autoComplete', {
                debounceDelay: 200,
                minLength: 1
            })
    }])
    .config( ($stateProvider, $locationProvider, $urlRouterProvider) => {
        'ngInject';

        let contentTypes = contentfulCustomCmsAppData.contentTypes;

        $urlRouterProvider.otherwise('/');

        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'header': {
                        template: headerView,
                        controller: headerCtrl
                    },
                    'sidebar': {
                        template: appSideView,
                        controller: AppCtrl
                    },
                    'content': {
                        template: appView,
                        controller: AppCtrl
                    },
                    'footer': {
                        template: footerView
                    }
                },
                resolve: {
                    contentTypes(ApiFactory) {
                        return ApiFactory.getContentTypes();
                    },
                    "currentAuth": ["$firebaseAuth", $firebaseAuth => {
                        // $requireSignIn returns a promise so the resolve waits for it to complete
                        // If the promise is rejected, it will throw a $stateChangeError (see above)
                        let auth = $firebaseAuth();
                        return auth.$requireSignIn();
                    }],
                    token: (FirebaseFactory, $cookies) => {
                        if (!!FirebaseFactory.getIdToken()) {
                            return FirebaseFactory.getIdToken().then((token) => {
                                $cookies.put('token', token);
                            });
                        }
                    }
                },
                params: { region: null }
            })
            .state('home', {
                url:'/:region',
                //redirectTo: 'app.file',
                views: {
                    'header': {
                        template: headerView,
                        controller: headerCtrl
                    },
                    'content': {
                        controller: AppHomeCtrl,
                        template: appHomeView
                    }
                },
                resolve: {
                    contentTypes() {
                        return null;
                    },
                    token: (FirebaseFactory, $cookies) => {
                        if (!!FirebaseFactory.getIdToken()) {
                            return FirebaseFactory.getIdToken().then((token) => {
                                $cookies.put('token', token);
                            });
                        }
                    }
                }
            })

            .state('app.home', {
                url: '/:region',
                views: {
                    'content': {
                        controller: AppHomeCtrl,
                        template: appHomeView
                    }
                },
                resolve: {
                    token: (FirebaseFactory, $cookies) => {
                        if (!!FirebaseFactory.getIdToken()) {
                            return FirebaseFactory.getIdToken().then((token) => {
                                $cookies.put('token', token);
                            });
                        }
                    }
                }
            })

            .state('app.user', {
                url: '/:region/user/:id',
                views: {
                    'content': {
                        template: appUserView,
                        controller: appUserCtrl
                    },
                    'sidebar': {
                        template: sideNavUserView,
                        controller: sideNavUserCtrl,
                        resolve: {
                            isAdmin: ($rootScope) => {
                                return $rootScope.firebaseUser.isAdmin;
                            },
                            users: (FirebaseFactory) => {
                                return FirebaseFactory.getOnceUsers().then( (users) => {
                                    let __users = users.val();
                                    let results = [];
                                    let keys = [];

                                    keys = Object.keys(__users);

                                    _.map(keys, (key) => {
                                        results.push(__users[key]);
                                    });

                                    return results;
                                }, (error) => {
                                    console.error(error);
                                });
                            },
                            token: (FirebaseFactory, $cookies) => {
                                if (!!FirebaseFactory.getIdToken()) {
                                    return FirebaseFactory.getIdToken().then((token) => {
                                        $cookies.put('token', token);
                                    });
                                }
                            }
                        }
                    }
                }
            })

            .state('app.file', {
                url: '/:region/file/:id',
                views: {
                    'content': {
                        template: appFileView,
                        controller: AppFileCtrl
                    },
                    'sidebar': {
                        template: appSideNavFilesView,
                        controller: AppSideNavFilesCtrl,
                        resolve: { }
                    }
                },
                resolve: {
                    token: (FirebaseFactory, $cookies) => {
                        if (!!FirebaseFactory.getIdToken()) {
                            return FirebaseFactory.getIdToken().then((token) => {
                                $cookies.put('token', token);
                            });
                        }
                    }
                },
                params: {page: 1, search: null}
            });

        contentTypes.forEach(section => {
            let id = section.sys.id;
            console.log('section', id);

            if (id === 'article') {
                $stateProvider
                    .state(`app.${id}`, {
                        url: `/:region/${id}`,
                        views: {
                            'content': {
                                template: appItemsView,
                            },
                            'sidebar': {
                                template: appSideItemsView
                            }
                        },
                        resolve: {
                            token: (FirebaseFactory, $cookies) => {
                                if (!!FirebaseFactory.getIdToken()) {
                                    return FirebaseFactory.getIdToken().then((token) => {
                                        $cookies.put('token', token);
                                    });
                                }
                            }
                        },
                        params: {
                            contentType: section
                        },
                        redirectTo: `app.${id}.list`
                    })
                    .state(`app.${id}.list`, {
                        url: '/list',
                        views: {
                            'content': {
                                controller: AppItemsListCtrl,
                                template: appItemsListView
                            },
                            'sidebar': {
                                template: sideNavBiggerView,
                                controller: sideNavCtrl
                            }
                        },
                        params: {page: 1, search: null}
                    })
                    .state(`app.${id}.add`, {
                        url: '/add',
                        views: {
                            'content': {
                                controller: AppItemsAddEditCtrl,
                                template: appItemsAddEditView
                            },
                            'sidebar': {
                                template: sideNavBiggerView,
                                controller: sideNavCtrl
                            }
                        },
                        params: {
                            mode: 'add',
                            page: 1,
                            contentType: section
                        }
                    })
                    .state(`app.${id}.edit`, {
                        url: '/edit/:id/:page',
                        views: {
                            'content': {
                                controller: AppItemsAddEditCtrl,
                                template: appItemsAddEditView
                            },
                            'sidebar': {
                                template: sideNavBiggerView,
                                controller: sideNavCtrl
                            }
                        },
                        params: {mode: 'edit', contentTypes, idChild: null, search: null}
                    })
                    .state(`app.${id}.detail`, {
                        url: '/detail/:id',
                        views: {
                            'content': {
                                controller: AppItemsDetailCtrl,
                                template: appItemsDetailView
                            },
                            'sidebar': {
                                template: sideNavBiggerView,
                                controller: sideNavCtrl
                            }
                        }
                    });
            }
            else if (id === 'page'){
                $stateProvider
                    .state(`app.${id}`, {
                        url: `/:region/${id}`,
                        views: {
                            'content': {
                                template: appItemsView,
                            },
                            'sidebar': {
                                template: sideNavView,
                                controller: sideNavCtrl
                            }
                        },
                        resolve: {
                            token: (FirebaseFactory, $cookies) => {
                                if (!!FirebaseFactory.getIdToken()) {
                                    return FirebaseFactory.getIdToken().then((token) => {
                                        $cookies.put('token', token);
                                    });
                                }
                            }
                        },
                        params: {
                            contentType: section
                        },
                        redirectTo: `app.${id}.list`
                    })
                    .state(`app.${id}.list`, {
                        url: '/list/:idNavigation',
                        views: {
                            'content': {
                                controller: AppPageCtrl,
                                template: appPageView
                            }
                        },
                        resolve: {
                            token: (FirebaseFactory, $cookies) => {
                                if (!!FirebaseFactory.getIdToken()) {
                                    return FirebaseFactory.getIdToken().then((token) => {
                                        $cookies.put('token', token);
                                    });
                                }
                            }
                        },
                        params: { idNavigation: null, page: 1, idParent: null, navTitle: null }
                    })
                    .state(`app.${id}.edit`, {
                        url: '/edit/:id/:idChild',
                        views: {
                            'content': {
                                controller: AppPageEditCtrl,
                                template: appPageEditView
                            }
                        },
                        resolve: {
                            token: (FirebaseFactory, $cookies) => {
                                if (!!FirebaseFactory.getIdToken()) {
                                    return FirebaseFactory.getIdToken().then((token) => {
                                        $cookies.put('token', token);
                                    });
                                }
                            }
                        },
                        params: { mode: 'edit', contentTypes, idChild: null, articles: [], titleParent: '' }
                    })
                    .state(`app.${id}.add`, {
                        url: '/add/:id',
                        views: {
                            'content': {
                                controller: AppPageEditCtrl,
                                template: appPageEditView
                            }
                        },
                        resolve: {
                            token: (FirebaseFactory, $cookies) => {
                                if (!!FirebaseFactory.getIdToken()) {
                                    return FirebaseFactory.getIdToken().then((token) => {
                                        $cookies.put('token', token);
                                    });
                                }
                            }
                        },
                        params: { mode: 'add', contentTypes, idChild: null, articles: [], titleParent: '' }
                    })
                    .state(`app.${id}.navigationitem`, {
                        url: '/navigationitem/:id/:type',
                        views: {
                            'content': {
                                controller: AppNavigationItemCtrl,
                                template: appNavigationItemView
                            }
                        },
                        resolve: {
                            token: (FirebaseFactory, $cookies) => {
                                if (!!FirebaseFactory.getIdToken()) {
                                    return FirebaseFactory.getIdToken().then((token) => {
                                        $cookies.put('token', token);
                                    });
                                }
                            }
                        },
                        params: { type: 'link', contentTypes, obj: null, add: null }
                    })
                    .state(`app.${id}.navigationitem.add`, {
                        url: '/navigationitem/:id/:type',
                        views: {
                            'content': {
                                controller: AppNavigationItemCtrl,
                                template: appNavigationItemView
                            }
                        },
                        resolve: {
                            token: (FirebaseFactory, $cookies) => {
                                if (!!FirebaseFactory.getIdToken()) {
                                    return FirebaseFactory.getIdToken().then((token) => {
                                        $cookies.put('token', token);
                                    });
                                }
                            }
                        },
                        params: { type: 'link', contentTypes, obj: null }
                    });
            }
        });

        $locationProvider.html5Mode(false);
    })
    .config(['AnalyticsProvider', (AnalyticsProvider) => {
        let host = window.location.host.split('.')[0];
        if (host.indexOf('localhost') >= 0 || host.indexOf('develop') >= 0) {
            AnalyticsProvider.setAccount('UA-108612405-1');
        } else {
            AnalyticsProvider.setAccount('UA-109723812-1');
        }

    }])
    .run(['Analytics', (Analytics) => { }])
    .name;



// WEBPACK FOOTER //
// ./src/app/app.js